module.exports = __webpack_public_path__ + "static/media/programLive.95e27762.svg";